import axios from "axios";
import { fetchUserSuccess } from "./../redux/UserDetails/UserActions";
import checkSession from "./checkSession";
import { setUserLogin } from "./../redux/UserDetails/UserActions";

export default function fetchUserData(
	usrID,
	dispatch,
	navigate,
	from_page = "home"
) {
	axios
		.post("/api/Login/user-status-me")
		.then((resp) => {
			if (resp?.data?.statusCode == 200 && resp?.data?.success) {
				dispatch(setUserLogin());
				dispatch(fetchUserSuccess(resp?.data?.data));
			} else {
				alert("Something went wrong")
				window.location.reload()
			}
		})
		.catch((error) => {
			if (error.message.includes("code 404")) {
				navigate("../Register", { replace: false });
			} else if (error.message.includes("code 444") || error.message.includes("code 421")) {
				checkSession(error, dispatch, navigate);
			}
		});
}
